import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  colspan: "3",
  class: "text-center"
}
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "form-field-floating reactive active my-4" }
const _hoisted_8 = { class: "form-field-floating reactive active my-4" }
const _hoisted_9 = { class: "flex-right" }
const _hoisted_10 = {
  colspan: "6",
  class: "text-center"
}

import { reactive, ref, watch } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import MarketProduitFormAddVariantModal from '../modals/MarketProduitFormAddVariantModal.vue';
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG } from '@/utils';
    import MarketProduitFormEditVariantModal from '../modals/MarketProduitFormEditVariantModal.vue';
    import MarketAttributsListModal from '../../market-attributs/modals/MarketAttributsListModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormAttributsView',
  props: {
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
        imagePreview: { type: String, required: false },
        id: { type: Number, default: null },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const addVariantModalRef = ref<InstanceType<typeof MarketProduitFormAddVariantModal> | null>(null);
    const editVariantModalRef = ref<InstanceType<typeof MarketProduitFormEditVariantModal> | null>(null);
    const attributsListModalRef = ref<InstanceType<typeof MarketAttributsListModal> | null>(null);
    const loading = ref(false);
    const formData = reactive({
        attributs: [] as any[],
        produit_attributs: [] as any[],
    });

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
            formData.produit_attributs.forEach((pAttribut) => {
                if (pAttribut.image && !pAttribut.image_preview) {
                    pAttribut.image_preview = pAttribut.image_url;
                }
            });
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });

    function addAttribut() {
        attributsListModalRef.value?.open().then((result) => {
            if (result) {
                const alreadyExists = formData.attributs.filter(attribut => attribut.nom === result.nom).length > 0;
                if (!alreadyExists) {
                    formData.attributs.push(result);
                }
            }
        });
    }

    async function onRemoveAttribut(attributIndex: number) {
        const confirmation = await confirmationModalRef.value?.open("Suppression Attribut", "Voulez-vous vraiment supprimer l'attribut sélectionné ?");
        if (confirmation) {
            if (formData.produit_attributs.filter(pAttribut => Object.keys(pAttribut.valeurs).lastIndexOf(formData.attributs[attributIndex].nom) > -1).length > 0) {
                throw new Error("Impossible de supprimer cet attribut car il est utilisé par une ou plusieurs variantes.");
            }
            //formData.variants = formData.variants.filter(variant => Object.keys(variant.valeurs).lastIndexOf(formData.attributs[attributIndex].nom) === -1);
            formData.attributs.splice(attributIndex, 1);
        }
    }

    async function openAddVariantModal() {
        const result = await addVariantModalRef.value?.open(props.startupFormDatas.produit);
        if (result) {
            formData.produit_attributs.push({
                guid: result.guid,
                nom: result.nom,
                valeurs: result.valeurs,
                produit_attributs: result.produit_attributs,
                montant: props.startupFormDatas.produit.montant,
                quantite: 0,
                images: [] as any[],
                images_previews: [] as any[],
            });
        }
    }

    async function openEditVariantModal(variant: any, index: number) {
        const result = await editVariantModalRef.value?.open(props.startupFormDatas.produit, variant);
        if (result) {
            Object.assign(formData.produit_attributs[index], {
                montant: result.montant,
                quantite: result.quantite,
                images: result.images ? result.images : [],
                images_previews: result.images_previews ? result.images_previews : [],
            });
        }
    }

    function onFileImageUploaded(variant: any, index: number, uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.produit_attributs[index].image_preview = uploadedFile.file_preview;
        formData.produit_attributs[index].image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_upload_input = _resolveComponent("custom-upload-input")!
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, " Gestion des attributs ", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { width: "45%" }, "Attributs"),
          _createElementVNode("th", { width: "45%" }, "Valeurs"),
          _createElementVNode("th", { width: "10%" })
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (formData.attributs.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("td", { colspan: "3" }, [
                _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun attribut ajouté")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.attributs, (attribut, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: 'attribut_row_' + index
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("h6", null, _toDisplayString(attribut.nom), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("h6", null, _toDisplayString(attribut.valeurs.join(', ')), 1)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_custom_button, {
                onClick: ($event: any) => (onRemoveAttribut(index)),
                classesList: 'btn-ultra white2 tips'
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-delete.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Supprimer", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createVNode(_component_custom_button, {
              onClick: addAttribut,
              type: "button",
              classesList: 'btn lg w-100',
              loading: loading.value
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "Ajouter un attribut", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "s20 my-0 hr2 opacity-1" }, null, -1)),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
    _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, " Gestion des variantes ", -1)),
    _createElementVNode("table", _hoisted_4, [
      _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th"),
          _createElementVNode("th", null, "Variante"),
          _createElementVNode("th", null, "Prix unitaire"),
          _createElementVNode("th", null, "Stock initial"),
          _createElementVNode("th", null, "Images"),
          _createElementVNode("th", { width: "10%" })
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (formData.produit_attributs.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("td", { colspan: "6" }, [
                _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucune variante ajoutée")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.produit_attributs, (pAttribut, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: 'produit_attribut_row_' + index
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_custom_upload_input, {
                  id: 'image_input_' + index,
                  label: "Image",
                  type: "IMAGE",
                  size: "small",
                  preview: pAttribut.image_preview ?? __props.imagePreview,
                  onUploaded: ($event: any) => (onFileImageUploaded(pAttribut, index, $event))
                }, null, 8, ["id", "preview", "onUploaded"])
              ])
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.attributs, (attribut, attrIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'produit_attribut_' + index + '_attribut_' + attrIndex
                }, [
                  _createElementVNode("strong", null, _toDisplayString(attribut.nom) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(pAttribut.valeurs[attribut.nom]), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                ]))
              }), 128))
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: pAttribut.montant,
                  "onUpdate:modelValue": ($event: any) => ((pAttribut.montant) = $event),
                  name: "montant",
                  id: "montant",
                  placeholder: ""
                }, { ref_for: true }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue", "onUpdate:modelValue"]),
                _cache[6] || (_cache[6] = _createElementVNode("label", { for: "montant" }, [
                  _createTextVNode("Prix unitaire "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: pAttribut.quantite,
                  "onUpdate:modelValue": ($event: any) => ((pAttribut.quantite) = $event),
                  name: "quantite",
                  id: "quantite",
                  placeholder: ""
                }, { ref_for: true }, _unref(INTEGER_FORMAT_CONFIG)), null, 16, ["modelValue", "onUpdate:modelValue"]),
                _cache[7] || (_cache[7] = _createElementVNode("label", { for: "quantite" }, "Stock initial", -1))
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(pAttribut.images.length) + " image(s) ", 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_custom_button, {
                  classesList: 'btn-ultra white2 tips',
                  onClick: ($event: any) => (openEditVariantModal(pAttribut, index))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("img", {
                      src: "/icons/icon-edit.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Modifier", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_custom_button, { classesList: 'btn-ultra white2 tips' }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("img", {
                      src: "/icons/icon-delete.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Supprimer", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_10, [
            _createVNode(_component_custom_button, {
              type: "button",
              classesList: 'btn lg w-100',
              loading: loading.value,
              onClick: openAddVariantModal
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createElementVNode("span", null, "Ajouter un variant", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "s20 my-0 hr2 opacity-1" }, null, -1)),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512),
    _createVNode(MarketProduitFormAddVariantModal, {
      ref_key: "addVariantModalRef",
      ref: addVariantModalRef,
      attributs: formData.attributs
    }, null, 8, ["attributs"]),
    _createVNode(MarketProduitFormEditVariantModal, {
      ref_key: "editVariantModalRef",
      ref: editVariantModalRef
    }, null, 512),
    _createVNode(MarketAttributsListModal, {
      ref_key: "attributsListModalRef",
      ref: attributsListModalRef
    }, null, 512)
  ]))
}
}

})